export default __webpack_public_path__ + "static/media/avatar_mice7.ca2e15c4.mp3";